import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import RoleGuard from "@/components/RoleGuard";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Invoices from "@/pages/Invoices";
import TransactionsIn from "@/pages/TransactionsIn";
import TransactionsOut from "@/pages/TransactionsOut";
import Capital from "@/pages/Capital";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Customers from "@/pages/Customers";
import Sales from "@/pages/Sales";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import UsersAdmin from "@/pages/UsersAdmin";
import StockLockModal from "@/components/StockLockModal";

function App() {
  return (
    <div className="App min-h-screen bg-[#FAFAFA] text-zinc-900">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route
                path="/dashboard"
                element={
                  <RoleGuard allow={["owner", "admin", "kasir"]} menuKey="dashboard">
                    <Dashboard />
                  </RoleGuard>
                }
              />
              <Route
                path="/faktur"
                element={
                  <RoleGuard allow={["owner", "admin", "kasir"]} menuKey="invoices">
                    <Invoices />
                  </RoleGuard>
                }
              />
              <Route
                path="/barang"
                element={
                  <RoleGuard allow={["owner", "admin", "kasir"]} menuKey="products">
                    <Products />
                  </RoleGuard>
                }
              />
              <Route
                path="/pelanggan"
                element={
                  <RoleGuard allow={["owner", "admin", "kasir"]} menuKey="customers">
                    <Customers />
                  </RoleGuard>
                }
              />
              <Route
                path="/sales"
                element={
                  <RoleGuard allow={["owner", "admin", "kasir"]} menuKey="sales_data">
                    <Sales />
                  </RoleGuard>
                }
              />
              <Route
                path="/masuk"
                element={
                  <RoleGuard allow={["owner", "admin", "kasir"]} menuKey="in">
                    <TransactionsIn />
                  </RoleGuard>
                }
              />
              <Route
                path="/keluar"
                element={
                  <RoleGuard allow={["owner", "admin", "kasir"]} menuKey="out">
                    <TransactionsOut />
                  </RoleGuard>
                }
              />
              <Route
                path="/modal"
                element={
                  <RoleGuard allow={["owner", "admin", "kasir"]} menuKey="capital">
                    <Capital />
                  </RoleGuard>
                }
              />
              <Route
                path="/laporan"
                element={
                  <RoleGuard allow={["owner", "admin", "kasir"]} menuKey="reports">
                    <Reports />
                  </RoleGuard>
                }
              />
              <Route
                path="/pengaturan"
                element={
                  <RoleGuard allow={["owner", "admin", "kasir"]} menuKey="settings">
                    <Settings />
                  </RoleGuard>
                }
              />
              <Route
                path="/pengguna"
                element={
                  <RoleGuard allow={["owner"]}>
                    <UsersAdmin />
                  </RoleGuard>
                }
              />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <StockLockModal />
    </div>
  );
}

export default App;
